import axios from "axios";

const API = "http://129.153.124.232:3000/api";

function authConfig(token) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const getCurrentUser = (token) =>
  axios.get(`${API}/auth/me`, authConfig(token));

export const getPendingUsers = (token) =>
  axios.get(`${API}/auth/pending`, authConfig(token));

export const approveUser = (token, userId) =>
  axios.post(`${API}/auth/approve`, { userId: String(userId) }, authConfig(token));

export const getUsers = (token, limit = 100, offset = 0) =>
  axios.get(`${API}/users`, {
    ...authConfig(token),
    params: { limit, offset },
  });

export const updateUser = (token, userId, values) =>
  axios.patch(`${API}/users/${encodeURIComponent(userId)}`, values, authConfig(token));

export const deactivateUser = (token, userId) =>
  axios.delete(`${API}/users/${encodeURIComponent(userId)}`, authConfig(token));